<script lang="ts" setup>
import ContactUsBtn from './ContactUsBtn.vue';
</script>

<template>
  <section class="px-4 py-16 text-center md:py-24">
    <h2 class="mb-6 text-3xl font-bold lg:text-5xl">It's that easy!</h2>
    <ContactUsBtn />
  </section>
</template>
